module.exports = __webpack_public_path__ + "media/images/dummy_gift-7d815d2d7cbe46ac3bbbbd06c4c1a435.png";